// extracted by mini-css-extract-plugin
export default {"RemovableItem":"RemovableItem_RemovableItem__swxHP","RemovableItemDisabled":"RemovableItem_RemovableItemDisabled__FZuA9"};